<template>
	<div class="app">
		<router-view />
	</div>
</template>

<script>
import "ant-design-vue/dist/antd.css"

export default {
	name: "App",
	mounted() {
		this.$context.authService.onAuth(() => {
			// console.log("onAuth")
			this.$router.replace({ name: "AuthIndex" }).catch()
		})
	}
}
</script>

<style lang="scss">
@import "./assets/scss/index";
</style>

<style lang="scss" scoped>
.app {
	height: 100%;
}
</style>
